import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Button } from "@mui/material";
import { deleteFAQ, getFAQs } from "./Helper";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { TablePagination } from "@mui/material";

const FAQList = () => {
  const context = useOutletContext();
  const navigate = useNavigate();
  const [faqs, setFAQs] = useState([]);
  const [faqPage, setFAQPage] = useState(0);
  const [faqLimit, setFAQLimit] = useState(10);
  const [faqTotal, setFAQTotal] = useState(0);
  const [update, setUpdate] = useState(false);

  const handleChangePage = (event, newPage) => {
    fetchData(newPage, faqLimit);
    setFAQPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setFAQLimit(parseInt(event.target.value, 10));
    setFAQPage(0);
    fetchData(0, parseInt(event.target.value, 10));
  };

  const fetchData = (page, limit) => {
    getFAQs(page, limit)
      .then((data) => {
        setFAQs(data.data.faq.rows);
        setFAQTotal(data.data.faq.totalItems);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    context(["FAQ", "Manage FAQ"]);
    getFAQs(faqPage, faqLimit)
      .then((data) => {
        setFAQs(data.data.faq.rows);
        setFAQTotal(data.data.faq.totalItems);
      })
      .catch((err) => console.log(err));
  }, [update]);
  return (
    <div className="p-5 shadow-md bg-white">
      <div class="flex w-full justify-between">
        <div class="flex-none">
          <h3
            className="col-span-5 text-lg uppercase tracking-wider font-bold inline"
            style={{ color: "#2EBAA3" }}
          >
            Manage FAQ
          </h3>
        </div>
        <div className="flex flex-row-reverse">
          <div className="px-2 w-52">
            <Button
              type="submit"
              variant="contained"
              style={{ color: "white" }}
              onClick={() => {
                navigate("/FAQ/Create", { state: { id: null } });
              }}
              fullWidth
            >
              Add FAQ
            </Button>
          </div>
          <div className="px-2 w-52">
            <Button
              type="submit"
              variant="contained"
              style={{ color: "white", textTransform: "unset" }}
              onClick={() => {
                navigate("/FAQ/Sort");
              }}
              fullWidth
            >
              SORT FAQs
            </Button>
          </div>
        </div>
      </div>
      <br />
      <div class="overflow-x-auto relative">
        <table class="w-full text-sm text-left text-gray-500">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" class="py-3 px-6 uppercase">
                ID
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Section
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Question
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Answer
              </th>
              <th scope="col" class="py-3 px-6 uppercase text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {faqs?.map((faq, index) => {
              console.log(faq);
              return (
                <tr class="bg-white border-b" key={faq?.id}>
                  <th
                    scope="row"
                    class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap cursor-pointer"
                    key={faq?.id}
                  >
                    {index + 1}
                  </th>
                  <td class="py-4 px-6">{faq?.section_name}</td>
                  <td class="py-4 px-6">{faq?.title}</td>
                  <td class="py-4 px-6">{faq?.description}</td>
                  <td class="py-4 px-6  text-center">
                    <div className="grid grid-cols-2 gap-2">
                      <IconButton
                        aria-label="edit"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/FAQ/Create", {
                            state: {
                              id: faq?.id,
                              title: faq?.title,
                              description: faq?.description,
                              section_name: faq?.section_name,
                            },
                          });
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        aria-label="delete"
                        onClick={(e) => {
                          e.preventDefault();
                          Swal.fire({
                            title: "Do you want to delete this FAQ?",
                            showCancelButton: true,
                            confirmButtonText: "Delete",
                            confirmButtonColor: "#2EBAA3",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              deleteFAQ(faq?.id)
                                .then((data) => {
                                  Swal.fire("Deleted", "", "success");
                                  setInterval(() => {
                                    setUpdate(!update);
                                  }, 200);
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                            }
                          });
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <TablePagination
        component="div"
        count={faqTotal}
        page={faqPage}
        onPageChange={handleChangePage}
        rowsPerPage={faqLimit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[2, 5, 10, 25, 50, 100]}
      />
    </div>
  );
};

export default FAQList;
